.quote {
  font-size: 1.5rem;
  font-style: italic;
  position: relative;
  white-space: pre-wrap;
}

.mark {
  color: var(--quote-icon-color, var(--color-border-primary));
  font-size: 4rem;
  left: 0;
  position: absolute;
  top: 0;
  width: 40px;
}

.body {
  padding-bottom: 1rem;
  padding-left: 40px;
  padding-top: 30px;
}

.meta {
  font-style: normal;
  padding-left: 64px;
}

.date {
  font-size: 0.875rem;
  white-space: nowrap;
}
